import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import { Skeleton } from '@mui/material';
import Stack from '@mui/material/Stack/Stack';
import Grid2 from '@mui/material/Unstable_Grid2';
import LinearProgress from '@mui/material/LinearProgress';
import { FilesCard } from './FilesCard';
import EditableOfferCard from '../EditableOfferCard/EditableOfferCard';
import { OfferCard } from './OfferCard';
import {
    inEmittedState,
    inProcessingState,
    inValidatingState,
    isDisclosedOrder,
    Order,
} from '../../../../../Models';
import { PatientCard } from './PatientCard';
import { usePrescriptionData } from '../../../../../services/api/queries/usePrescriptionData';
import { ChatBox } from '../ChatBox/ChatBox';
import SummaryCard from './SummaryCard/SummaryCard';
import { CustomerHistoryCard } from './CustomerHistoryCard';

type OrderDialogContentProps = {
    order: Order;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    onDone: () => void;
    currentView: 'whatsapp' | 'files' | 'historial';
};
export default function OrderDialogContent({
    order,
    setLoading,
    onDone,
    currentView,
}: OrderDialogContentProps) {
    const prescriptionData = usePrescriptionData(order);
    const { isLoading: isFilesLoading, files } = prescriptionData;
    return (
        <DialogContent>
            <Grid2 container sx={{ mt: 1, height: 1 }} spacing={1}>
                <Grid2 xs={7} spacing={1} height="100%">
                    <Stack spacing={1} height="100%">
                        <SummaryCard order={order} />
                        {isDisclosedOrder(order) && <PatientCard order={order} />}
                        {(inProcessingState(order) || order.state === 'fulfilled') && (
                            <OfferCard order={order} />
                        )}
                        {(inEmittedState(order) || inValidatingState(order)) && isFilesLoading && (
                            <Skeleton variant="rectangular" width="100%" height="100%" />
                        )}
                        {(inEmittedState(order) || inValidatingState(order)) && !isFilesLoading && (
                            <EditableOfferCard
                                order={order}
                                setLoading={setLoading}
                                onDone={onDone}
                                prescriptionData={prescriptionData}
                            />
                        )}
                    </Stack>
                </Grid2>
                {currentView === 'whatsapp' && !inEmittedState(order) && (
                    <Grid2 xs height="100%">
                        <ChatBox order={order} />
                    </Grid2>
                )}
                {currentView === 'files' && (
                    <Grid2 xs height="100%">
                        {isFilesLoading && <LinearProgress />}
                        {!isFilesLoading && <FilesCard files={files} order={order} />}
                    </Grid2>
                )}
                {currentView === 'historial' && (
                    <Grid2 xs height="100%">
                        <CustomerHistoryCard order={order} />
                    </Grid2>
                )}
            </Grid2>
        </DialogContent>
    );
}
